import { z } from 'zod';

export const restoreBackupResponseSchema = z.object({
  url: z.string(),
  identity: z.object({
    agentName: z.string(),
    personality: z.record(z.unknown()),
  }),
  checksum: z.string(),
});

export const restoreBackupRequestSchema = z.object({
  shopId: z.string().uuid(),
  deviceId: z.string(),
  backupId: z.string().uuid().optional(),
});

export type RestoreBackupResponse = z.infer<typeof restoreBackupResponseSchema>;
export type RestoreBackupRequest = z.infer<typeof restoreBackupRequestSchema>;
